import React from "react";
import Optoutmodal from "../Notificationscomponents/Optoutmodal";
import ProductsModal from "../Notificationscomponents/ProductsModal";
import ListMessageModal from "../Notificationscomponents/ListMessageModal";
import CustomReplyModal from "../Notificationscomponents/CustomReplyModal";
import WorkflowSettingsModal from "../Notificationscomponents/WorkflowSettingsModal";

const Modals = ({
  showOptOutModal,
  setShowOptOutModal,
  showProductsModal,
  setShowProductsModal,
  showListMessageModal,
  setShowListMessageModal,
  showCustomReplyModal,
  setShowCustomReplyModal,
  showWorkflowModal,
  setShowWorkflowModal,
  setOptOutConfig,
  setProductsConfig,
  setListMessageConfig,
  setCustomReplyConfig,
  setWorkflowConfig
}) => {
  return (
    <>
      {showOptOutModal && (
        <Optoutmodal
          show={showOptOutModal}
          handleClose={() => setShowOptOutModal(false)}
          onSave={(config) => setOptOutConfig(config)}
        />
      )}
      {showProductsModal && (
        <ProductsModal
          show={showProductsModal}
          handleClose={() => setShowProductsModal(false)}
          onSave={(config) => setProductsConfig(config)}
        />
      )}
      {showListMessageModal && (
        <ListMessageModal
          show={showListMessageModal}
          handleClose={() => setShowListMessageModal(false)}
          onSave={(config) => setListMessageConfig(config)}
        />
      )}
      {showCustomReplyModal && (
        <CustomReplyModal
          show={showCustomReplyModal}
          handleClose={() => setShowCustomReplyModal(false)}
          onSave={(config) => setCustomReplyConfig(config)}
        />
      )}
      {showWorkflowModal && (
        <WorkflowSettingsModal
          show={showWorkflowModal}
          handleClose={() => setShowWorkflowModal(false)}
          onSave={(config) => setWorkflowConfig(config)}
        />
      )}
    </>
  );
};

export default Modals;